import type { PasswordlessUserDto } from '@/api/types'

import { addToast } from '@heroui/toast'
import { QueryCache, QueryClient } from '@tanstack/react-query'

import { getUserControllerFindSelfUserQueryKey } from '@/api/user/user'
import { getErrorMessage } from '@/shared/lib/axios'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      const errMsg = getErrorMessage(error)

      addToast({
        color: 'danger',
        title: 'Error',
        description: errMsg,
      })
    },
  }),
})

export const setQueryCache = {
  userInfo: (data: PasswordlessUserDto) =>
    queryClient.setQueryData(getUserControllerFindSelfUserQueryKey(), data),
}

export const getQueryCache = {
  userInfo: () => queryClient.getQueryData(getUserControllerFindSelfUserQueryKey()),
}

export const invalidateQueryCache = {
  userInfo: () => queryClient.setQueryData(getUserControllerFindSelfUserQueryKey(), null),
}
